import SimplePage from "../components/site/SimplePage";

const sections = [
  {
    title: "Volunteer",
    text: "Support teaching, health camps, or outreach events with flexible schedules."
  },
  {
    title: "Partner",
    text: "Collaborate with us on CSR initiatives, community programs, and impact reporting."
  },
  {
    title: "Fundraise",
    text: "Start a campaign with friends, schools, or corporate teams to fund a project."
  }
];

function GetInvolved() {
  return (
    <SimplePage
      title="Get Involved"
      lead="There are many ways to stand with communities and create measurable change."
      sections={sections}
    />
  );
}

export default GetInvolved;
